import { render } from "./EditEmail.vue?vue&type=template&id=38e248b6&scoped=true"
import script from "./EditEmail.vue?vue&type=script&lang=js"
export * from "./EditEmail.vue?vue&type=script&lang=js"

import "./EditEmail.vue?vue&type=style&index=0&id=38e248b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e248b6"]])

export default __exports__